import React from "react";
import { Card, Layout, SkeletonBodyText, SkeletonPage } from "@shopify/polaris";

export function PurchaseOrderNewPageSkeleton(): React.JSX.Element {
  return (
    <SkeletonPage narrowWidth>
      <Layout>
        <Layout.Section>
          <Card>
            <SkeletonBodyText lines={4} />
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
